import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import GetAppIcon from "@material-ui/icons/GetApp";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { getRequest, postRequest } from "../../globalhelper/helper";
import { useDispatch, useSelector } from "react-redux";
import { navUrl } from "../../redux/Common/commonActions";
import moment from "moment";
import _ from "lodash";
import { externals } from "../../config.json";
import { Accordion, AccordionDetails, AccordionSummary, Alert, Autocomplete, Box, Grid, IconButton, Pagination, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DatePicker } from "@mui/x-date-pickers";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { CSVLink } from "react-csv";
import { GetApp } from "@material-ui/icons";
import { Cloud } from "@mui/icons-material";
function TablePaginationActions(props) {
  const theme = useTheme();
  const {
    count,
    page,
    rowsPerPage,
    onPageChange
  } = props;
  const [previousCount, setPreviousCount] = useState(count);
  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0);
    }
    setPreviousCount(count);
  }, [count, page, onPageChange, previousCount]);
  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return <Box sx={{
    flexShrink: 0,
    ml: 2.5
  }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>;
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});
const DocumentTypes = ["Supplier Bill", "Transporter Bill"];
function Indicator() {
  const [DocumentType, setDocumentType] = useState("");
  const [AllCompanies, setAllCompanies] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [Companies, setCompanies] = useState([]);
  const [ThemeNames, setthemeNames] = useState([]);
  const [ThemeName, setThemeName] = useState("");
  const [Company, setCompany] = useState("");
  const [GSTINs, setGSTINs] = useState([]);
  const [GSTIN, setGSTIN] = useState("");
  const [From, setFrom] = useState("");
  const [To, setTo] = useState("");
  const [AllRecentHistory, setAllRecentHistory] = useState([]);
  const [RecentHistory, setRecentHistory] = useState([]);
  const [FNSError, setFNSError] = useState("");
  const state = useSelector(state => state);
  const Vendors = [{
    VendorName: "M&C SAATCHI MOBILE INDIA LLP",
    VendorID: "VM0000000030"
  }];
  const [vendor, setVendor] = useState({});
  const dispatch = useDispatch();
  const navPage = url => {
    dispatch(navUrl(url));
  };
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(({
      res
    }) => {
      setCompanies((res.data || []).sort((a, b) => (a.orgname || "").localeCompare(b.orgname || "")));
      setAllCompanies((res.data || []).sort((a, b) => (a.orgname || "").localeCompare(b.orgname || "")));
    }).catch(setErrorMessage);
    var currentDate = moment();
    var firstDay = currentDate.startOf("month").format("YYYY-MM-DD");
    var lastDay = currentDate.endOf("month").format("YYYY-MM-DD");
    setFrom(firstDay);
    setTo(lastDay);
  }, []);
  useEffect(() => {
    postRequest("api/transactions/getTransactions").then(resp => {
      if (resp.type === "success") {
        const DATA = JSON.parse(resp.res.data);
        console.log(DATA);
        const sortedRows = DATA.sort((a, b) => {
          const dateA = a.Start ? a.Start / 1000000 : new Date(a.Created_At).getTime();
          const dateB = b.Start ? b.Start / 1000000 : new Date(b.Created_At).getTime();
          return dateB - dateA;
        });
        setAllRecentHistory(sortedRows);
        setRecentHistory(sortedRows);
      }
    });
  }, []);
  useEffect(() => {
    if (!Company.orgid) return;
    postRequest("api/upload/uploadV4Credentials", {
      orgid: Company.orgid,
      transactionType: "RoyaltyJournalDump"
    }).then(response => {
      const result = response.res.data;
      setthemeNames(result.themename || []);
    });
  }, [Company]);
  const updateCompany = val => {
    setCompany(val);
    console.log(RecentHistory.length);

    // Filter GSTINs if applicable
    let GSTIN = [];
    AllCompanies.map(each => {
      if (each.orgid === val?.orgid) {
        GSTIN.push(each.GSTIN);
      }
    });
    setGSTINs(GSTIN);
  };
  useEffect(() => {
    if (AllRecentHistory.length) {
      setPage(0);
      let filteredData = [...AllRecentHistory];
      if (Company) {
        filteredData = filteredData.filter(each => each["OrgId"] === Company.orgid);
      }
      setRecentHistory(filteredData);
    }
  }, [Company, AllRecentHistory]);
  const fileInputOnChange = async e => {
    const {
      MAX_TOTAL_SIZE
    } = externals;
    let file = e.target.files[0];
    let additionalParam = "BT3I"; // Default process code

    if (file && file.size <= Number(MAX_TOTAL_SIZE)) {
      setFNSError("");
      const formData = new FormData();
      formData.append("file", file);

      // Removed TransactionType and ThemeName from query params
      postRequest(`api/upload/singleUpload2?OrgID=${Company.orgid}&TransactionType=&ThemeName=&GSTIN=${GSTIN}&From=${From}&To=${To}&ProcessCode=${additionalParam}&DocType=${DocumentType}`, formData).then(res => {
        console.log(res);
      });
    } else if ((file.name.includes("pdf") || file.name.includes("xlsx") || file.name.includes("csv")) && Number(MAX_TOTAL_SIZE) <= file.size) {
      setFNSError(`The total size of all files must not exceed 50 MB. Currently: ${(file.size / (1024 * 1024)).toFixed(2)} MB`);
    } else {
      setFNSError("File extension is mismatching");
    }
    e.target.value = null;
  };
  const downloadCSV = () => {
    if (!Company) {
      console.error("Company must be selected before downloading the file.");
      return;
    }

    // Removed TransactionType and ThemeName from query params
    postRequest(`api/upload/getcsv?OrgID=${Company.orgid}&TransactionType=&ThemeName=`, {
      responseType: "json"
    }).then(res => {
      if (res?.res?.data?.type === "Buffer" && Array.isArray(res.res.data.data)) {
        const byteArray = new Uint8Array(res.res.data.data);
        const contentType = res?.res?.headers?.["content-type"] || "application/octet-stream";
        const blob = new Blob([byteArray], {
          type: contentType
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Indicator_${Company.orgname}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Invalid file data structure:", res.res.data);
      }
    }).catch(err => {
      console.error("Error downloading file:", err);
    });
  };
  const downloadICFile = async TransID => {
    try {
      if (!Company) {
        console.error("Company must be selected before downloading the file.");
        return;
      }
      // Removed TransactionType and ThemeName from query params
      const response = await postRequest(`api/upload/getICFile?OrgID=${Company.orgid}&TransactionType=&ThemeName=&TransID=${TransID}`, {
        responseType: "json"
      });
      if (response?.res?.data.type === "Buffer" && Array.isArray(response?.res?.data.data)) {
        const byteArray = new Uint8Array(response.res.data.data);
        const contentType = response?.res?.headers?.["content-type"] || "application/octet-stream";
        const blob = new Blob([byteArray], {
          type: contentType
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${TransID}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleErrorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorMessage("");
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessMessage("");
  };
  const refreshRow = (transaction, OrgId) => {
    // Removed TransactionType from query params
    postRequest(`api/upload/refreshTransaction?OrgID=${OrgId}&TransactionId=${transaction}&TransactionType=`).then(res => {
      if (res.type === "success") {
        window.location.reload();
      }
    });
  };
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - RecentHistory.length) : 0;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const [expandedRows, setExpandedRows] = useState({});
  const toggleReadMore = rowIndex => {
    setExpandedRows(prev => ({
      ...prev,
      [rowIndex]: !prev[rowIndex]
    }));
  };
  return <Box>
      <Snackbar open={Boolean(errorMessage)} onClose={handleErrorClose} autoHideDuration={6000} anchorOrigin={{
      horizontal: "right",
      vertical: "top"
    }}>
        <Alert severity="error" onClose={handleErrorClose}>
          {errorMessage.toString()}
        </Alert>
      </Snackbar>
      <Snackbar open={Boolean(successMessage)} onClose={handleSuccessClose} autoHideDuration={6000} anchorOrigin={{
      horizontal: "right",
      vertical: "top"
    }}>
        <Alert severity="success" onClose={handleSuccessClose}>
          {successMessage}
        </Alert>
      </Snackbar>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
          <Typography variant="h6">Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={3}>
              <Autocomplete size="small" fullWidth value={Company || null} options={Companies} getOptionLabel={option => option?.orgname || ""} isOptionEqualToValue={(option, value) => option.orgid === value?.orgid} onChange={(event, newValue) => updateCompany(newValue)} renderInput={params => <TextField {...params} label="Company" variant="outlined" name="Company" />} />
            </Grid>
            <Grid item xs={3}>
              <Autocomplete size="small" fullWidth value={ThemeName || null} options={ThemeNames} getOptionLabel={option => option} onChange={(event, newValue) => setThemeName(newValue)} renderInput={params => <TextField {...params} label="Theme Name" variant="outlined" name="ThemeName" />} />
            </Grid>
            {Company && <Grid item xs={2}>
                <Button variant="contained" color="success" onClick={downloadCSV}>
                  Download
                </Button>
              </Grid>}
          </Grid>
          <Grid container gap={2} marginTop={4}>
            {Company?.orgid === "OM0000000002" && <Grid item xs={3}>
                <Autocomplete size="small" fullWidth value={vendor || null} options={Vendors} getOptionLabel={option => option?.VendorName || ""} isOptionEqualToValue={(option, value) => option.VendorID === value?.VendorID} onChange={(event, newValue) => setVendor(newValue)} renderInput={params => <TextField {...params} label="Vendor" variant="outlined" name="Vendor" />} />
              </Grid>}

            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="ForPrdFrom" value={From} views={["day", "month", "year"]} onChange={newValue => {
                setFrom(newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label="ForPrdTo" value={To} views={["day", "month", "year"]} onChange={newValue => {
                setTo(newValue.format("YYYY-MM-DD"));
              }} renderInput={params => <TextField fullWidth size="small" {...params} />} />
              </LocalizationProvider>
            </Grid>
            {Company.orgid && <Grid item xs={2}>
                <Button disabled={!Company || !From || !To} component="label" variant="contained" startIcon={<CloudUploadIcon />}>
                  Upload file
                  <VisuallyHiddenInput multiple type="file" onChange={fileInputOnChange} />
                </Button>
                &nbsp;
                <small style={{
              color: "red"
            }}>{FNSError}</small>
              </Grid>}
          </Grid>
        </AccordionDetails>
      </Accordion>
      {RecentHistory.length > 0 && Company.orgid ? <>
          <Box align="right" sx={{
        m: 2,
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: 2
      }}>
            <Pagination count={Math.ceil(RecentHistory.length / rowsPerPage)} page={page + 1} onChange={(event, newPage) => {
          handleChangePage(event, newPage - 1);
        }} variant="outlined" shape="rounded" showFirstButton showLastButton />
            &nbsp;
            <CSVLink size="sm" filename={`indicator_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`} data={RecentHistory}>
              <Button variant="contained" color="success">
                <GetApp />
              </Button>
            </CSVLink>
          </Box>
          <Grid container>
            <Grid item mb={2} mt={2}>
              <Typography variant="h6">Recently Uploaded</Typography>
            </Grid>
            <TableContainer component={Paper}>
              <Table sx={{
            minWidth: 650
          }} size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  {((rowsPerPage > 0 ? RecentHistory.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : RecentHistory) && (rowsPerPage > 0 ? RecentHistory.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : RecentHistory).length > 0 ? Object.keys((rowsPerPage > 0 ? RecentHistory.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : RecentHistory)[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
                  textAlign: 'left'
                }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {((rowsPerPage > 0 ? RecentHistory.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : RecentHistory) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
                  let displayVal = val;
                  if (typeof val === 'number' && !Number.isInteger(val)) {
                    displayVal = val.toFixed(2);
                  } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                    displayVal = parseFloat(val).toFixed(2);
                  } else if (typeof val === 'boolean') {
                    displayVal = val ? 'Yes' : 'No';
                  } else if (val === null || val === undefined) {
                    displayVal = '';
                  } else if (typeof val === 'object') {
                    displayVal = JSON.stringify(val);
                  }
                  return <TableCell key={valIndex} sx={{
                    textAlign: 'left'
                  }}>
                          {String(displayVal)}
                        </TableCell>;
                })}
                  </TableRow>)}
              </TableBody>
            </Table>
            </TableContainer>
          </Grid>
        </> : ""}
    </Box>;
}
export default Indicator;